import { createSlice } from '@reduxjs/toolkit';
import { Nullable, ConversationStarterCategory } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';

import { ReducerState } from '../configure-store';
import {
    createConversationCategory,
    deleteConversationCategory,
    getAllConversationCategory,
    getConversationCategory,
    listConversationCategory,
    updateConversationCategory,
} from '../thunks/conversation-starter-category-thunks';

export interface ConversationStarterCategoryState extends ReducerState {
    data: Paginated<ConversationStarterCategory>;
    current: Nullable<ConversationStarterCategory>;
}

const initialState: ConversationStarterCategoryState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'conversation-starter-category',
    initialState,
    reducers: {
        resetConversationStarterCategoryCurrent: (state: ConversationStarterCategoryState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(listConversationCategory.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listConversationCategory.rejected, takeOne.rejectedActionCase)

            .addCase(getAllConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(getAllConversationCategory.fulfilled, takeOne.fulfilledActionCase)
            .addCase(getAllConversationCategory.rejected, takeOne.rejectedActionCase)

            .addCase(getConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(getConversationCategory.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getConversationCategory.rejected, takeOne.rejectedActionCase)

            .addCase(createConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(createConversationCategory.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createConversationCategory.rejected, takeOne.rejectedActionCase)

            .addCase(updateConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(updateConversationCategory.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateConversationCategory.rejected, takeOne.rejectedActionCase)

            .addCase(deleteConversationCategory.pending, takeOne.pendingActionCase)
            .addCase(deleteConversationCategory.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteConversationCategory.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetConversationStarterCategoryCurrent } = slice.actions;

export default slice.reducer;
